import React from 'react';
import { Link } from 'react-router';

require('./stylesheets/Navigation.scss');


const Navigation = React.createClass({
  getInitialState() {
    return {
      isMenuActive: false,
    }
  },

  componentDidMount() {
    this.menu = document.getElementById('mega-menu');
  },

  toggleMenu() {
    this.setState({ isMenuActive: !this.state.isMenuActive })
    document.body.classList.toggle('hideOverflow');
  },

  render() {
    return (
      <nav className="primary-nav">
        <div className="site-title">
          <h1><Link to="/"><span className="accent">Nathan</span>Kleekamp</Link></h1>
        </div>
        <div className="hamburger" id="hamburger" onClick={ this.toggleMenu }>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
        <div className={ this.state.isMenuActive ? 'mega-menu active' : 'mega-menu' } id="mega-menu">
          <div className="close" id="close" onClick={ this.toggleMenu }>
            <span>&#10006;</span>
          </div>
          <ul className="nav">
            <li><Link to="/" onClick={ this.toggleMenu }>Home</Link></li>
            <li><Link to="/portfolio/" onClick={ this.toggleMenu }>Portfolio</Link></li>
            <li><Link to="/contact/" onClick={ this.toggleMenu }>Contact</Link></li>
          </ul>
        </div>
      </nav>
    );
  }
});

export default Navigation;



// WEBPACK FOOTER //
// ./app/src/App/components/Navigation.js